import React from 'react';

export function AgentIcon({
  w = 14,
  h = 15,
  color = 'currentColor',
  disabled = false
}: {
  w?: number;
  h?: number;
  color?: string;
  disabled?: boolean;
}) {
  return (
    <svg
      width={w}
      height={h}
      opacity={disabled ? 0.5 : 1}
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9.16718 6.71631H10.8338C13.1908 6.71631 14.3693 6.71631 15.1016 7.44854C15.8338 8.18078 15.8338 9.35931 15.8338 11.7163C15.8338 14.0733 15.8338 15.2518 15.1016 15.9841C14.3693 16.7163 13.1908 16.7163 10.8338 16.7163H10.0005C10.0005 16.7163 9.58384 18.383 6.66718 18.383C6.66718 18.383 7.50051 17.5424 7.50051 16.7019C6.20597 16.6629 5.43383 16.5185 4.89941 15.9841C4.16718 15.2518 4.16718 14.0733 4.16718 11.7163C4.16718 9.35931 4.16718 8.18078 4.89941 7.44854C5.63164 6.71631 6.81015 6.71631 9.16718 6.71631Z"
        stroke={color}
        strokeWidth="1.25"
        strokeLinejoin="round"
      />
      <path
        d="M15.8338 9.6333H16.2505C17.0293 9.6333 17.4187 9.6333 17.7088 9.8008C17.8988 9.91047 18.0566 10.0683 18.1663 10.2583C18.3338 10.5484 18.3338 10.9378 18.3338 11.7166C18.3338 12.4955 18.3338 12.8849 18.1663 13.175C18.0566 13.365 17.8988 13.5228 17.7088 13.6325C17.4187 13.8 17.0293 13.8 16.2505 13.8H15.8338"
        stroke={color}
        strokeWidth="1.25"
        strokeLinejoin="round"
      />
      <path
        d="M4.16718 9.6333H3.75051C2.97166 9.6333 2.58224 9.6333 2.29218 9.8008C2.10215 9.91047 1.94435 10.0683 1.83464 10.2583C1.66718 10.5484 1.66718 10.9378 1.66718 11.7166C1.66718 12.4955 1.66718 12.8849 1.83464 13.175C1.94435 13.365 2.10215 13.5228 2.29218 13.6325C2.58224 13.8 2.97166 13.8 3.75051 13.8H4.16718"
        stroke={color}
        strokeWidth="1.25"
        strokeLinejoin="round"
      />
      <path
        d="M11.25 2.96631C11.25 3.65667 10.6903 4.21631 10 4.21631C9.30967 4.21631 8.75 3.65667 8.75 2.96631C8.75 2.27595 9.30967 1.71631 10 1.71631C10.6903 1.71631 11.25 2.27595 11.25 2.96631Z"
        stroke={color}
        strokeWidth="1.25"
      />
      <path d="M10 4.21631V6.71631" stroke={color} strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M7.5 10.0498V10.8831M12.5 10.0498V10.8831"
        stroke={color}
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.3338 13.7998C8.3338 13.7998 8.88938 14.2165 10.0005 14.2165C11.1116 14.2165 11.6671 13.7998 11.6671 13.7998"
        stroke={color}
        strokeWidth="1.25"
        strokeLinecap="round"
      />
    </svg>
  );
}
